import { Row, Col } from 'react-bootstrap';

export default function Atendimento() {
    return <Row>
        <Col xs="12">
            <p><small>Você está em <a href="/institucional">Institucional</a> / Atendimento</small></p>
            <h1>Atendimento</h1>
            <h3>Contatos</h3>
            <p>PABX: (081) 3183-2211</p>
            <p>E-mail: ouvidoria@alepe.pe.gov.br</p>
            
            <h3>Horário de atendimento</h3>
            <p>Segunda-feira à quinta-feira: 08:00 às 18:00h</p>
            <p>Sexta-feira: 08:00 às 13:00h</p>

            <h3>Localização</h3>
            <h5>Sede: Edifício Governador Miguel Arraes de Alencar</h5>
            <p>Rua da União, 397 - Boa Vista, Recife/PE</p>
            <p>CEP: 50050-909</p>

            <h5>Gabinetes parlamentares: Anexo II - Edf. João Negromonte Filho</h5>
            <p>Rua da União, 383 - Boa Vista, Recife/PE</p>
            <p>CEP: 50050-909</p>

            <h5>Setores administrativos: Anexos I, III, V e VI</h5>
            <p>Rua da União, 439 - Boa Vista, Recife/PE</p>
            <p>CEP: 50050-909</p>

            <h5>Museu Palácio Joaquim Nabuco</h5>
            <p>Rua da Aurora, 631 (acesso pela Rua da União) - Boa Vista, Recife/PE</p>
            <p>CEP: 50050-145</p>

            <h5>Escola do Legislativo (Elepe)</h5>
            <p>Rua da Aurora, 763 - Santo Amaro, Recife/PE</p>
            <p>CEP: 50050-145</p>

            <h5>Sup. de Saúde e Medicina Ocupacional</h5>
            <p>Rua das Fronteiras, 83 - Boa Vista, Recife /PE</p>
            <p>CEP: 50070–170</p>

            <h5>Sup. de Comunicação Social - Edf. Joaquim Francisco</h5>
            <p>Rua da União, 380 - Boa Vista, Recife/PE</p>
            <p>CEP: 50050-010</p>
        </Col>
    </Row>
}
